/**
 * @fileoverview Layout and calendar-grid constants for the home calendar.
 * @module components/HomeCalendar/homeCalendarConstants
 */

export const DAYS_PER_WEEK = 7;
export const FIRST_MONTH_INDEX = 0;
export const LAST_MONTH_INDEX = 11;
export const PCT_FULL = 100;
export const BASE_TOP = 30;
export const ROW_HEIGHT = 28;
export const EVENT_HEIGHT = 24;
export const CELL_WIDTH = PCT_FULL / DAYS_PER_WEEK;
export const MAX_VISIBLE_ITEMS = 4;
export const SUNDAY_REFERENCE_YEAR = 2024;
export const SUNDAY_REFERENCE_MONTH = 0;
export const SUNDAY_REFERENCE_DAY = 7;
export const EVENTS_ROUTE = "/events";
